import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Switch, Route,withRouter} from 'react-router-dom';
import * as permissions from '../utilities/permissions';
import Login from '../components/app/Login';
import Book from '../components/app/jre/book';
import requireAuth from '../utilities/require-auth';
// import {useEffect, useState} from "react";



class Routes extends React.Component {

  // constructor(props) {
  //     // super(props);
  //     // this.state = {
  //     //     loading: false
  //     // };
  // }

  componentDidMount() {
    // setTimeout(() => {
    //   this.setState({loading: true});
    // }, 5000)
    // if(localStorage.getItem('recordId') != null){
    //   localStorage.removeItem('recordId');
    // }

  }

      render() {
          // const {role} = this.props;
          // if (permissions.isStudent(role)) {
          // /login/:sectionid/:moduleid/:scheduledid/:scheduledtype/:studentid/:nouser/:type
          // if(!this.state.loading){
          //      return <div>
          //      <img style={{position: "absolute",top: "57%",left: "50%"}}
          //     src="https://devapp.staracademyapp.com/assets/media/logos/Logo_aStar.svg"
          //     alt="new"
          //       />
          //     </div>
          //  }else{
            return (
                <Router>
                    <div>
                        <Switch>
                        <Route path="/login/:sectionId/:moduleId/:scheduledId/:scheduledType/:studentId/:studentId1/:lang(en|es)?/:rest*" component={Login}/>
                        <Route exact path="/view/modules/:bookId(\d+)/assignments/:assignmentId" component={Book} />
                        <Route exact path="/view/modules/:bookId(\d+)/assignments/:assignmentId/sections/:sectionId" component={Book} />
                        <Route exact path="/view/modules/:bookId/assignments/:assignmentId/sections/:sectionId/pages/:pageNum(\d+)" component={Book} />
                        <Route exact path="/view/modules/:bookId(\d+)/assignments/:assignmentId/sections/:sectionId/pages/:pageNum(\d+)/extendid/:extendedContentId(\d+)" component={Book} />
                        <Route path="/:sectionId/:moduleId/:scheduledId/:scheduledType/:studentId/:studentId1/:pageId/:lang(en|es)?/:rest*" component={Login}/>
                        <Route exact path="/view/modules/:bookId(\d+)/sections/:sectionId/pages/:pageNum(\d+)"
                          component={Book}/>
                        </Switch>
                    </div>
                </Router>
            );
          // }

        }
  }





Routes.propTypes = {
    user: PropTypes.object.isRequired
};

const mapStateToProps = (state) => (
    {
      auth: state.auth,
      user: state.auth.user
    }
);

export default connect(
    mapStateToProps,
    null
)(Routes);



// WEBPACK FOOTER //
// ./src/js/routes/index.js